function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#3A77FF",
  d: "M15.693 45.409l-2.424-1.351V27.863c0-7.798 6.38-14.142 14.223-14.142h3.475c7.842 0 14.223 6.344 14.223 14.142 0 7.798-6.38 14.143-14.223 14.143h-9.534a.682.682 0 00-.434.157l-.186.132-5.12 3.114z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#CEDDFF",
  d: "M27.006 31.145l-.186-.132a.687.687 0 00-.434-.156h-9.534c-7.841 0-14.223-6.345-14.223-14.143 0-7.799 6.38-14.143 14.222-14.143h3.475c7.842 0 14.223 6.344 14.223 14.143v16.194l-2.425 1.351-5.12-3.114z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#002F34",
  strokeWidth: 5,
  d: "M25.978 21.71s-5.663 6.866-12.413-.654"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#002F34",
  d: "M14.895 9.906c-2.367 0-4.286 1.905-4.286 4.255 0 2.35 1.919 4.254 4.286 4.254 2.367 0 4.285-1.905 4.285-4.254 0-2.35-1.918-4.255-4.285-4.255m0 2.978c.709 0 1.285.573 1.285 1.277 0 .703-.576 1.276-1.285 1.276-.71 0-1.286-.573-1.286-1.276 0-.704.577-1.277 1.286-1.277"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#002F34",
  strokeWidth: 5,
  d: "M25.978 13.867h-5.024"
}));

const SvgSupport = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 48,
  height: 48
}, props), _ref);

export default SvgSupport;